define('webshopFiltersView',[
  'module',
  'app',
  'backbone',
  'marionette',
  'underscore',
  'buttonView',
  'modalView',
  'modalsAlertView',
  'webshopFiltersListView',
  'webshopFiltersDetailView',
  'webshopFiltersEditView',
  'entities/webshop/filters',
  'template!webshopFiltersView',
  'entities/webshop/webshop'
], function (
  Module,
  App,
  Backbone,
  Marionette,
  _,
  ButtonView,
  ModalView,
  AlertView,
  ListView,
  DetailView,
  EditView,
  FiltersApi,
  Tpl
) {
  'use strict';

  // Webshop > Filters: the product filters of the category pages (webshop cws_filter_* tables).
  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'webshop-filters-view',

    regions: {
      addRegion: '.add-region',
      listRegion: '.list-region',
      detailRegion: '.detail-region'
    },

    ui: {
      search: 'input.search'
    },

    events: {
      'input @ui.search': 'onSearch'
    },

    initialize: function () {
      this.languages = ['fr', 'en', 'de', 'nl'];
      this.groups = [];
    },

    onShow: function () {
      this.addButton = new ButtonView({
        type: 'add',
        color: 'orange',
        text: _.i18n('webshop.filters.add', null, 'New filter')
      });
      this.addButton.on('click', _.bind(this.onAdd, this));
      this.getRegion('addRegion').show(this.addButton);

      this.listView = new ListView();
      this.listView.on('select', _.bind(this.showFilter, this));
      this.getRegion('listRegion').show(this.listView);

      App.request('webshop.config').done(_.bind(function (config) {
        // Webshop storefront languages (it, da, es...) on top of the default four.
        _.each(config.getLanguages(), function (lang) {
          if (lang && !_.contains(this.languages, lang))
            this.languages.push(lang);
        }, this);
      }, this));

      FiltersApi.groups().done(_.bind(function (groups) {
        // Mutated in place: the detail views keep a reference to this array.
        _.each(groups, function (g) {
          this.groups.push({id: g.id, label: FiltersApi.name(g.names) || g.id});
        }, this);
      }, this));

      this.fetch();
    },

    fetch: function () {
      return FiltersApi.search().done(_.bind(function (filters) {
        if (!this.isDestroyed)
          this.listView.setFilters(filters);
      }, this)).fail(function (message) {
        AlertView.prototype.open('', message);
      });
    },

    onSearch: function () {
      this.listView.setQuery(this.ui.search.val());
    },

    showFilter: function (id) {
      this.listView.setSelected(id);
      this.getRegion('detailRegion').show(new DetailView({
        filterId: id,
        languages: this.languages,
        groups: this.groups,
        onChanged: _.bind(this.fetch, this),
        onDeleted: _.bind(function () {
          this.getRegion('detailRegion').empty();
          this.fetch();
        }, this)
      }));
    },

    onAdd: function () {
      ModalView.prototype.open({
        childView: EditView,
        kind: 'filter',
        languages: this.languages,
        groups: this.groups,
        model: new Backbone.Model({names: {}, code: '', groupId: 'webshop'}),
        title: _.i18n('webshop.filters.add', null, 'New filter'),
        confirmButtonText: _.i18n('common.create', null, 'Create'),
        onConfirm: _.bind(function (model) {
          FiltersApi.add({
            names: model.get('names'),
            code: model.get('code'),
            groupId: model.get('groupId')
          }).done(_.bind(function (result) {
            this.fetch().done(_.bind(function () {
              this.showFilter(result.id);
            }, this));
          }, this)).fail(function (message) {
            AlertView.prototype.open('', message);
          });
        }, this)
      });
    }
  });
});

